module.exports = __webpack_public_path__ + "img/img3.be2536c4.jpg";